import { $playerReferrals } from '../../../../../../app/backend/store/referrals';
import Settings from '../../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 44,
    TINT: {
        LABEL: 0x334039,
        NUMBER: 0x7caee0,
    },
};

export default class TotalFriends extends Phaser.GameObjects.Container {
    private label!: Phaser.GameObjects.BitmapText;
    private number!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupLabel();
        this.setupNumber();
    }

    setupLabel() {
        this.label = this.scene.add.bitmapText(0, 0, LABEL.FONT, this.scene.cache.json.get('i18n')['my_friends'], LABEL.SIZE);
        this.label.setTint(LABEL.TINT.LABEL);
        this.add(this.label);
    }

    setupNumber() {
        let x = 200;
        let y = 0;
        let text = '(0)';

        this.number = this.scene.add.bitmapText(x, y, LABEL.FONT, text, LABEL.SIZE);
        this.number.setTint(LABEL.TINT.NUMBER);
        this.add(this.number);

        $playerReferrals.watch(incomingReferrals => this.number.setText('(' + incomingReferrals.length + ')'))
    }
}
